import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';

class BasicDetails extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
    };
  }

componentDidMount(){
  this.get_emp_basic_details();
}
get_emp_basic_details(){
    var cutThis           = this;
    var emp_id            = cutThis.props.id;
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var body = new FormData();
    body.append('emp_id',emp_id);
    body.append('web_token',web_token);
    body.append('form_type','employee_basic_details');
    body.append('function','get_emp_basic_details');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
    }else{
      url = "/php/admin_employee_management_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         data: body
     })
     .then(function (res) {
        var data = res.data;
        if(data['error']==1){
          var new_data = data['data'];
          cutThis.update_info(new_data);
        }

     })
     .catch(function (error) {
         console.log(error);
     });
}

update_info(data){
  $('#user_full_name ').val(data['user_full_name']);
  $('#bate_of_birth').val(data['bate_of_birth']);
  $('#gender').val(data['gender']);
  $('#nationality').val(data['nationality']);
  $('#marital_status').val(data['marital_status']);
  $('#blood_group').val(data['blood_group']);
  $('#religion').val(data['religion']);
  $('#father_name').val(data['father_name']);
  $('#spouse_name').val(data['spouse_name']);
  $('#emergency_contact').val(data['emergency_contact']);
}

add_emp_basic_details(){
  var cutThis           = this;
  var emp_id            = cutThis.props.id;
  var web_token         = window.isNullAndUndef($('#web_token').val());
  var user_full_name    = window.isNullAndUndef($('#user_full_name').val());
  var bate_of_birth     = window.isNullAndUndef($('#bate_of_birth').val());
  var gender            = window.isNullAndUndef($('#gender').val());
  var nationality       = window.isNullAndUndef($('#nationality').val());
  var marital_status    = window.isNullAndUndef($('#marital_status').val());
  var blood_group       = window.isNullAndUndef($('#blood_group').val());
  var religion          = window.isNullAndUndef($('#religion').val());
  var father_name       = window.isNullAndUndef($('#father_name').val());
  var spouse_name       = window.isNullAndUndef($('#spouse_name').val());
  var emergency_contact = window.isNullAndUndef($('#emergency_contact').val());
  var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
  cutThis.setState({submit_button});
  $('label').removeClass('color_red');
  if(user_full_name && bate_of_birth && gender && nationality && marital_status && blood_group && religion && father_name && spouse_name && emergency_contact){
    var all_data                    = {};
    all_data['user_full_name']      = user_full_name;
    all_data['bate_of_birth']       = bate_of_birth;
    all_data['gender']              = gender;
    all_data['nationality']         = nationality;
    all_data['marital_status']      = marital_status;
    all_data['blood_group']         = blood_group;
    all_data['religion']            = religion;
    all_data['father_name']         = father_name;
    all_data['spouse_name']         = spouse_name;
    all_data['emergency_contact']   = emergency_contact;
    var body = new FormData();
    body.append('emp_id',emp_id);
    body.append('emp_date',JSON.stringify(all_data));
    body.append('web_token',web_token);
    body.append('form_type','employee_basic_details');
    body.append('function','add_emp_basic_details');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
    }else{
      url = "/php/admin_employee_management_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         data: body
     })
     .then(function (res) {
        var data = res.data;
        $('#error_msg').text(data['msg']);
        submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
        cutThis.setState({submit_button});
     })
     .catch(function (error) {
         console.log(error);
     });
  }else {
    window.change_lable_color('user_full_name','bate_of_birth','gender','nationality','marital_status','blood_group','religion','father_name','spouse_name','emergency_contact');
    submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
    cutThis.setState({submit_button});
  }

}

  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="user_full_name" placeholder="Full Name"/>
                                        <label for="name">Full Name</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="date" className="form-control" id="bate_of_birth" placeholder="Date of Birth"/>
                                        <label for="name">Date of Birth</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="gender" name="form_type">
                                        <option value="">Gender</option>
                                        <option value="Female">Female</option>
                                        <option value="Male">Male</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <label for="name">Gender</label>
                                    </div>
                                </div>


                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="nationality" placeholder="Nationality"/>
                                        <label for="name">Nationality</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="marital_status" name="form_type">
                                        <option value="">Marital Status</option>
                                        <option value="Single">Single</option>
                                        <option value="Married">Married</option>
                                        <option value="Widowed">Widowed</option>
                                        <option value="Divorced">Divorced</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <label for="name">Marital Status</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="blood_group" name="form_type">
                                        <option value="">Blood Group</option>
                                        <option value="A+">A+</option>
                                        <option value="A-">A-</option>
                                        <option value="B+">B+</option>
                                        <option value="B-">B-</option>
                                        <option value="O+">O+</option>
                                        <option value="O-">O-</option>
                                        <option value="AB+">AB+</option>
                                        <option value="AB-">AB-</option>
                                    </select>
                                    <label for="name">Blood Group</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="religion" name="form_type">
                                        <option value="">Religion</option>
                                        <option value="Hindus">Hindus</option>
                                        <option value="Muslims">Muslims</option>
                                        <option value="Christians">Christians</option>
                                        <option value="Sikhs">Sikhs</option>
                                        <option value="Buddhists">Buddhists</option>
                                        <option value="Jains">Jains</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <label for="name">Religion</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="father_name" placeholder="Father's Name / Mother's Name"/>
                                        <label for="name">Father's Name / Mother's Name</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="spouse_name" placeholder="Spouse's Name"/>
                                        <label for="name">Spouse's Name</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="emergency_contact" placeholder="Emergency Contact Details"/>
                                        <label for="name">Emergency Contact Details</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                <div className="col-md-8">
                                  <p id="error_msg"></p>
                                </div>
                                  <div className="col-md-4 p-0 float_r">
                                      {this.state.submit_button}
                                  </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default BasicDetails;
